export const host = 'https://app.teexpress.com.au/api'  // 接口地址

// export const host = 'https://tyky.hn-enjoy.com/api'  // 接口地址


// WEBPACK FOOTER //
// ./src/axios/config.js